module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6n5r9r3n-fe79ff4c1f8b0f69d7f402bc832abf09.svg";